module.exports = __webpack_public_path__ + "img/logo-dark-white-text.3553ce3d.svg";